import React, { useEffect, useState } from 'react'
import { Col, Form, Row } from 'react-bootstrap';
import { IoIosArrowDown } from 'react-icons/io';
import { ErrorMessage, Field, FieldArray, } from 'formik';
import { BiTrash } from 'react-icons/bi';
import { VscDiffAdded } from 'react-icons/vsc';
import { config } from '../../../CommonUtilities/CommonUrl/CommonUrls';
import { CommonAxiosGet } from '../../../CommonUtilities/CommonAxios/CommonAxios';
import { isIntegrated, } from './ProfessionQualification';
import {  handleNumericDot } from '../../../CommonUtilities/Validations/RegularExpAndVar';
import { calculatePercentage } from '../../../CommonUtilities/CommonFunctions/CommonFunction';

export function MappUgValuetoPqValue(ugvalue) {
  let pqvalue;
  switch (ugvalue) {
    case "Q105":
      pqvalue = 40;
      break;
    case "Q106":
      pqvalue = 42;
      break;
    case "Q107":
      pqvalue = 46;
      break;
    case "Q108":
      pqvalue = 47;
      break;
    case "Q110":
      pqvalue = 44;
      break;
    case "Q109":
      pqvalue = 43;
      break;
    default:
      pqvalue = '';
  }
  return pqvalue
}
export function SetIntegratedCourse(value, pq_length, Formik) {
  let pqvalue = MappUgValuetoPqValue(value);
  if (pqvalue !== '') {
    let Url = config.url.CONTEXT_READ_URL + "prof-subjects?course_code=" + pqvalue;
    CommonAxiosGet(Url).then((res) => {
      if (res?.data?.status === true) {
        let options = res?.data?.profsubjects?.map((ds, i) => (
          <option key={i} value={ds?.id}>{ds?.subject}</option>
        ));
        Formik.setFieldValue(`isPq`, "Yes"); // added
        Formik.setFieldValue(`pq[${pq_length}].courseCode`, pqvalue);
        Formik.setFieldValue(`selectedCourses[${pq_length}]`, options);
        Formik.setFieldValue(`pq[${pq_length}].subject1`, "");
        Formik.setFieldValue(`pq[${pq_length}].subject2`, "");
      } else {
        Formik.setFieldValue(`pq[${pq_length}].courseCode`, '');
        Formik.setFieldValue(`pq[${pq_length}].univCode`, "");
        Formik.setFieldValue(`pq[${pq_length}].subject1`, "");
        Formik.setFieldValue(`pq[${pq_length}].subject2`, "");
        Formik.setFieldValue(`selectedCourses[${pq_length}]`, []);
      }
    });
  }
  else {
    Formik.setFieldValue(`selectedCourses[${pq_length}]`, []);

  }
}
export default function Degree(props) {
  const { Formik, years, showUgData, showCourse,setPqData, showUniversities } = props

  useEffect(() => {
  const ugList = Formik.values.ug || [];
  ugList?.forEach((item, index) => {
    const percent = calculatePercentage(
      item?.marksSecured,
      item?.totalMarks
    );
    if (item.percentage !== percent) {
      Formik.setFieldValue(`ug[${index}].percentage`, percent);
    }
  });
}, [Formik.values.ug]);
  useEffect(() => {
    if (showUgData && showUgData?.length > 0) {
      showUgData.forEach((data, index) => {
        Formik.setFieldValue(`ug[${index}].univCode`, data?.univ_code);
        Formik.setFieldValue(`ug[${index}].mediumId`, data?.medium_id);
         Formik.setFieldValue(`ug[${index}].isEnglishUg`, data?.is_english_ug);
        Formik.setFieldValue(`ug[${index}].yearOfPass`, data?.year_of_pass);
        Formik.setFieldValue(`ug[${index}].hallTicket`, data?.hall_ticket);
        Formik.setFieldValue(`ug[${index}].courseCode`, data?.course_code);
        if (data?.courseCode !== 'Q99') {
        Formik.setFieldValue(`ug[${index}].secondLanguage`, data?.second_language);
        }

        handleUnivFilter(data?.course_code, index);
        GetsubData(data?.course_code, index);
        // SetIntegratedCourse(data?.course_code, index, Formik);
        Formik.setFieldValue(`ug[${index}].totalMarks`, data?.total_marks);
        Formik.setFieldValue(`ug[${index}].marksSecured`, data?.marks_secured);
        Formik.setFieldValue(`ug[${index}].percentage`, calculatePercentage(data?.marks_secured, data?.total_marks  ));
        Formik.setFieldValue(`ug[${index}].subject1`, data?.subject_1);
        Formik.setFieldValue(`ug[${index}].subject2`, data?.subject_2);
        Formik.setFieldValue(`ug[${index}].subject3`, data?.subject_3);
        Formik.setFieldValue(`ug[${index}].subject4`, data?.subject_4);

      });
    }
  }, [showUgData]);

  const [showSub, setSub] = useState({})
  const GetsubData = (courseCode, index) => {
    let Url = config.url.CONTEXT_READ_URL + "ug-pg-subjects?course_code=" + courseCode;
    CommonAxiosGet(Url).then((res) => {
      if (res?.data?.status === true) {
        let options = res?.data?.ugpgsubjects?.map((ds, i) => {
          return (
            <option key={i} value={ds.subject_code}>{ds.subject_name}</option>
          );
        });
        setSub((prevState) => ({
          ...prevState,
          [index]: options,
        }));
      }
      else {
        setSub((prevState) => ({
          ...prevState,
          [index]: [],
        }));
      }

    });
  }

  function setValuesToPq(value, course_code, name) {
    let pq_prev_code = MappUgValuetoPqValue(course_code) + '';
    let pq_prev_index = Formik?.values?.pq.findIndex(item => item.courseCode == pq_prev_code);
    let pq_index = pq_prev_index;
    let set_name = `pq[${pq_index}].${name}`
    //  console.log("set_name",set_name)
    if (isIntegrated(course_code)) {
      Formik.setFieldValue(set_name, value);
    }
  }
  const [showUniv, setUniv] = useState({})
  function handleUnivFilter(course_code, index) {
    let univ_code = showCourse?.filter((val) => val.course_code === course_code)[0]?.univ_code
    let data = showUniversities?.filter((val) => val.univ_code === univ_code)?.map((ds, i) => {
      return (<option key={i} value={ds.univ_code}>{ds.univ_name}</option>);
    })
    if (data?.length > 0) {
      setUniv((prevState) => ({
        ...prevState,
        [index]: data,
      }));
    }
    else {
      setUniv((prevState) => ({
        ...prevState,
        [index]: showUniversities?.map((ds, i) => {
          return (<option key={i} value={ds.univ_code}>{ds.univ_name}</option>);
        }),
      }));
    }
  }

  function pqDeleteRow(code, Formik) {
    let pqvalues = Formik?.values?.pq;
    let ug_value = code;
    let pq_value = MappUgValuetoPqValue(ug_value);
    let filtered_pq_delete = pqvalues?.filter((val) => val?.courseCode != pq_value);
    // console.log("filtered_pq:::",filtered_pq_delete);
   
    // alert("1")
    

    if (isIntegrated(ug_value) && filtered_pq_delete?.length) {
      // alert("2")
      setPqData(...filtered_pq_delete)
      Formik.setFieldValue('pq', filtered_pq_delete);
    }
  }


  // const [showPqLen, setPqLen] = useState(Formik?.values?.pq?.length)
  return (
    <React.Fragment>
    <div className='personal-block mb-2'>
      <div className="personal-head">
        <span> Degree or its Equivalent Qualification:</span>
      </div>
      <div className="personal-row mb-3">
        <FieldArray name="ug">
          {(formikFieldArray) => {
            return formikFieldArray.form.values.ug?.map((experienceDetails, index) => {

              let pq_length = Formik.values?.pq?.length;
              //Formik.values?.pq?.length;
              {/* setPqLen(pq_length) */ }
              {/* const pq_index = pq_length - 1; */ }
              return (
                <div key={index}>
                  <div className="personal-row mb-3">
                    <Row className="row mb-2" id={index}>
                      <Col xxl={3} xl={3} lg={4} md={6} sm={12} xs={12} className='mb-3'>
                        <div className="input-div position-relative">
                          <Form.Group>
                            <Form.Label className="input-lable mb-2">Course <font color="red">*</font></Form.Label>
                            <Field as="select" className="input-field form-control"
                              name={`ug[${index}].courseCode`}
                              onChange={(e) => {
                                let code = e.target.value;
                                let prev_code = Formik?.values?.ug[index]?.courseCode;
                                let pq_prev_code = MappUgValuetoPqValue(prev_code) + '';
                                let pq_prev_index = Formik?.values?.pq.findIndex(item => item.courseCode == pq_prev_code);
                                let pq_index = pq_prev_index !== -1 ? pq_prev_index : pq_length;
                                GetsubData(code, index);
                                handleUnivFilter(code, index);
                                Formik.setFieldValue(`ug[${index}].univCode`, "");
                                Formik.setFieldValue(`ug[${index}].hallTicket`, "");
                                Formik.setFieldValue(`ug[${index}].subject1`, "");
                                Formik.setFieldValue(`ug[${index}].subject2`, "");
                                Formik.setFieldValue(`ug[${index}].subject3`, "");
                                Formik.setFieldValue(`ug[${index}].subject4`, "");
                                Formik.setFieldValue(`ug[${index}].totalMarks`, "");
                                Formik.setFieldValue(`ug[${index}].marksSecured`, "");
                                Formik.setFieldValue(`ug[${index}].yearOfPass`, "");
                                Formik.setFieldValue(`ug[${index}].secondLanguage`, "");
                                Formik.setFieldValue(`ug[${index}].percentage`, "");
                                Formik.setFieldValue(`ug[${index}].mediumId`, "");
                                if (isIntegrated(code)) {
                                  if (pq_prev_index !== -1) {
                                    pq_index = pq_prev_index;
                                  }
                                  else {
                                    pq_index = pq_length;
                                  }
                                  SetIntegratedCourse(code, pq_index, Formik);
                                }
                                // else{
                                // let pqClone = [...Formik.values.pq];
                                // pqClone[pq_index].courseCode = "";
                                // pqClone = pqClone?.filter(row => row.courseCode !== "");
                                 
                                // Formik.setFieldValue("pq", pqClone);
                                // Formik.setFieldValue(`selectedCourses[${pq_index}]`, []);
                                // } 
                                else {
  let pqClone = [...Formik.values.pq];

  if (pqClone[pq_index]) {
    pqClone[pq_index] = {
      ...pqClone[pq_index],
      courseCode: ""
    };

    pqClone = pqClone.filter(
      row => row?.courseCode && row.courseCode !== ""
    );

    Formik.setFieldValue("pq", pqClone);
  }

  Formik.setFieldValue(`selectedCourses[${pq_index}]`, []);
}
                                }}
                                >
                              <option value="">Select</option>
                              {showCourse?.filter((val) => val.course_level === 'DEGREE')?.map((ds, i) => {
                                return (<option key={i} value={ds.course_code}
                                  disabled={Formik?.values?.ug?.some(item => String(item.courseCode) === String(ds.course_code))}
                                >{ds.course_name}</option>);
                              })}
                            </Field>
                            <ErrorMessage
                              name={`ug[${index}].courseCode`}
                              component="div"
                              className="text-error"
                            />
                          </Form.Group>
                          <IoIosArrowDown className="dropdown-icon" />
                        </div>
                      </Col>
                      <Col xxl={3} xl={3} lg={4} md={6} sm={12} xs={12} className='mb-3'>
                        <div className="input-div position-relative">
                          <Form.Group>
                            <Form.Label className="input-lable mb-2">University  <font color="red">*</font></Form.Label>
                            <Field as="select" className="input-field form-control"
                              name={`ug[${index}].univCode`}
                              onChange={(e) => {
                                let code = e.target.value;
                                setValuesToPq(code, experienceDetails?.courseCode, `univCode`)
                              }}
                            >
                              <option value="">Select</option>
                              {showUniv[index]}
                            </Field>
                            <ErrorMessage
                              name={`ug[${index}].univCode`}
                              component="div"
                              className="text-error"
                            />
                          </Form.Group>
                          <IoIosArrowDown className="dropdown-icon" />
                        </div>
                      </Col>
                      <Col xxl={3} xl={3} lg={4} md={6} sm={12} xs={12} className='mb-3'>
                        <div className="input-div position-relative">
                          <Form.Group>
                            <Form.Label className="input-lable mb-2">Subject 1 <font color="red">*</font></Form.Label>
                            <Field as="select"
                              className="input-field form-control"
                              name={`ug[${index}].subject1`}
                            >
                              <option value="">Select</option>
                              {showSub[index]}
                            </Field>
                            <ErrorMessage
                              name={`ug[${index}].subject1`}
                              component="div"
                              className="text-error"
                            />
                          </Form.Group>
                          <IoIosArrowDown className="dropdown-icon" />
                        </div>
                      </Col>
                      {showSub[index]?.length >= 2 && (
                        <Col xxl={3} xl={3} lg={4} md={6} sm={12} xs={12} className='mb-3'>
                          <div className="input-div position-relative">
                            <Form.Group>
                              <Form.Label className="input-lable mb-2">Subject 2</Form.Label>
                              <Field as="select"
                                className="input-field form-control"
                                name={`ug[${index}].subject2`}>
                                <option value="">Select</option>
                                {showSub[index]}
                              </Field>
                              <ErrorMessage
                                name={`ug[${index}].subject2`}
                                component="div"
                                className="text-error"
                              />
                            </Form.Group>
                            <IoIosArrowDown className="dropdown-icon" />
                          </div>
                        </Col>
                      )}
                      {showSub[index]?.length >= 3 && (
                        <Col xxl={3} xl={3} lg={4} md={6} sm={12} xs={12} className='mb-3'>
                          <div className="input-div position-relative">
                            <Form.Group>
                              <Form.Label className="input-lable mb-2">Subject 3</Form.Label>
                              <Field as="select"
                                className="input-field form-control"
                                name={`ug[${index}].subject3`}>
                                <option value="">Select</option>
                                {showSub[index]}
                              </Field>
                              <ErrorMessage
                                name={`ug[${index}].subject3`}
                                component="div"
                                className="text-error"
                              />
                            </Form.Group>
                            <IoIosArrowDown className="dropdown-icon" />
                          </div>
                        </Col>
                      )}
                      {showSub[index]?.length >= 4 && (
                        <Col xxl={3} xl={3} lg={4} md={6} sm={12} xs={12} className='mb-3'>
                          <div className="input-div position-relative">
                            <Form.Group>
                              <Form.Label className="input-lable mb-2">Subject 4</Form.Label>
                              <Field as="select"
                                className="input-field form-control"
                                name={`ug[${index}].subject4`}>
                                <option value="">Select</option>
                                {showSub[index]}
                              </Field>
                              <ErrorMessage
                                name={`ug[${index}].subject4`}
                                component="div"
                                className="text-error"
                              />
                            </Form.Group>
                            <IoIosArrowDown className="dropdown-icon" />
                          </div>
                        </Col>
                      )}


                      <Col xxl={3} xl={3} lg={4} md={6} sm={12} xs={12} className='mb-3'>
                        <div className="input-div position-relative">
                          <Form.Group>
                            <Form.Label className="input-lable mb-2">Select Medium  <font color="red">*</font></Form.Label>
                            <Field as="select"
                              className="input-field form-control"
                              name={`ug[${index}].mediumId`}
                              onChange={(e) => {
                                let code = e.target.value;
                                setValuesToPq(code, experienceDetails?.courseCode, `mediumId`)
                                // setValuesToPq(index, code,experienceDetails?.courseCode, `pq[${pq_index}].mediumId`)
                              }}
                            >
                              <option value="">Select</option>
                              <option value="1">TELUGU</option>
                              <option value="2">URDU</option>
                              <option value="3">HINDI</option>
                              <option value="4">KANNADA</option>
                              <option value="5">ORIYA</option>
                              <option value="6">TAMIL</option>
                              <option value="7">ENGLISH</option>
                              {/* <option value="8">SANSKRIT</option> */}

                            </Field>
                            <ErrorMessage
                              name={`ug[${index}].mediumId`}
                              component="div"
                              className="text-error"
                            />
                          </Form.Group>
                          <IoIosArrowDown className="dropdown-icon" />
                        </div>
                      </Col>
                      {Formik?.values?.ug[index]?.courseCode !== 'Q99' && (<Col xxl={3} xl={3} lg={4} md={6} sm={12} xs={12} className='mb-3'>
                        <div className="input-div position-relative">
                          <Form.Group >
                            <Form.Label className="input-lable mb-2">2nd Language  <font color="red">*</font></Form.Label>
                            <Field as="select"
                              className="input-field form-control"
                              name={`ug[${index}].secondLanguage`}>
                              <option value="">Select</option>
                              <option value="1">TELUGU</option>
                              <option value="2">URDU</option>
                              <option value="3">HINDI</option>
                              <option value="4">KANNADA</option>
                              <option value="5">ORIYA</option>
                              <option value="6">TAMIL</option>
                              <option value="7">ENGLISH</option>
                              <option value="8">SANSKRIT</option>
                              <option value="10">ARABIC</option>
                            </Field>
                            <ErrorMessage
                              name={`ug[${index}].secondLanguage`}
                              component="div"
                              className="text-error"
                            />
                          </Form.Group>
                          <IoIosArrowDown className="dropdown-icon" />
                        </div>
                      </Col>)}

                      <Col xxl={3} xl={3} lg={4} md={6} sm={12} xs={12} className='mb-3'>
                        <Form.Group  >
                          <Form.Label className="input-lable mb-2">Hall Ticket No  <font color="red">*</font></Form.Label>
                          <Field
                            type="text"
                            onChange={(e) => {
                              let code = e.target.value;
                              setValuesToPq(code, experienceDetails?.courseCode, `hallTicket`)
                              // setValuesToPq(index, code,experienceDetails?.courseCode, `pq[${pq_index}].hallTicket`)
                            }}
                            name={`ug[${index}].hallTicket`}
                            className="input-field form-control"
                            placeholder="Enter Hall Ticket Number"
                            maxLength={15}
                          />
                          <ErrorMessage
                            name={`ug[${index}].hallTicket`}
                            component="div"
                            className="text-error"
                          />
                        </Form.Group>
                      </Col>
                      <Col xxl={3} xl={3} lg={4} md={6} sm={12} xs={12} className='mb-3'>
                        <div className="input-div position-relative">
                          <Form.Group >
                            <Form.Label className="input-lable mb-2">Year of Passing <font color="red">*</font> </Form.Label>
                            <Field as="select"
                              className="input-field form-control"
                              name={`ug[${index}].yearOfPass`}
                              onChange={(e) => {
                                let code = e.target.value;
                                setValuesToPq(code, experienceDetails?.courseCode, `yearOfPass`)
                                // setValuesToPq(index, code,experienceDetails?.courseCode, `pq[${pq_index}].yearOfPass`)
                              }}
                            ><option value="">Select</option>
                              {years?.filter(year => year !== 2026).map((year) => (
                                <option key={year} value={year}>
                                  {year}
                                </option>
                              ))}
                            </Field><ErrorMessage
                              name={`ug[${index}].yearOfPass`}
                              component="div"
                              className="text-error"
                            />
                          </Form.Group>
                          <IoIosArrowDown className="dropdown-icon" />
                        </div>
                      </Col>
                       <Col xxl={3} xl={3} lg={4} md={6} sm={12} xs={12} className='mb-3'>
                        <Form.Group >
                          <Form.Label className="input-lable mb-2">Total Marks <font color="red">*</font></Form.Label>
                          <Field
                            type="text"
                            name={`ug[${index}].totalMarks`}
                            className="input-field form-control"
                            maxLength="4"
                            onChange={(e) => {
                              let code = e.target.value;
                              setValuesToPq(code, experienceDetails?.courseCode, `totalMarks`)
                              handleNumericDot(e);
                              // setValuesToPq(index, code,experienceDetails?.courseCode, `pq[${pq_index}].percentage`)
                            }}
                          />
                          <ErrorMessage
                            name={`ug[${index}].totalMarks`}
                            component="div"
                            className="text-error"
                          />
                        </Form.Group>
                      </Col>
                       <Col xxl={3} xl={3} lg={4} md={6} sm={12} xs={12} className='mb-3'>
                        <Form.Group >
                          <Form.Label className="input-lable mb-2">Marks Secured<font color="red">*</font></Form.Label>
                          <Field
                            type="text"
                            name={`ug[${index}].marksSecured`}
                            className="input-field form-control"
                            maxLength="4"
                            onChange={(e) => {
                              let code = e.target.value;
                              setValuesToPq(code, experienceDetails?.courseCode, `marksSecured`)
                              handleNumericDot(e);
                              // setValuesToPq(index, code,experienceDetails?.courseCode, `pq[${pq_index}].percentage`)
                            }}
                          />
                          <ErrorMessage
                            name={`ug[${index}].marksSecured`}
                            component="div"
                            className="text-error"
                          />
                        </Form.Group>
                      </Col>
                      <Col xxl={3} xl={3} lg={4} md={6} sm={12} xs={12} className='mb-3'>
                        <Form.Group >
                          <Form.Label className="input-lable mb-2">Percentage of marks(including languages) <font color="red">*</font></Form.Label>
                          <Field
                            type="text"
                            name={`ug[${index}].percentage`}
                            className="input-field form-control"
                            maxLength="4"
                            onChange={(e) => {
                              let code = e.target.value;
                              setValuesToPq(code, experienceDetails?.courseCode, `percentage`)
                              handleNumericDot(e);
                              // setValuesToPq(index, code,experienceDetails?.courseCode, `pq[${pq_index}].percentage`)
                            }}
                          />
                          <ErrorMessage
                            name={`ug[${index}].percentage`}
                            component="div"
                            className="text-error"
                          />
                        </Form.Group>
                      </Col>
   <Col xxl={3} xl={3} lg={4} md={6} sm={12} xs={12} className='mb-3'>
                        <Form.Group >
                          <Form.Label className="input-lable mb-2">Have you studied English as one of your Subjects ?<font color="red">*</font></Form.Label>
                           <div className="form-border">
                <Field
                  type="radio"
                name={`ug[${index}].isEnglishUg`}
                  value="Yes"
                  className="form-sub me-1"
                />
                Yes &nbsp;&nbsp;&nbsp;&nbsp;
                <Field
                  type="radio"
                  value="No"
                 name={`ug[${index}].isEnglishUg`}
                  className="form-sub me-1"
                />
                No &nbsp;&nbsp;&nbsp;&nbsp;
              </div>
                          <ErrorMessage
                            name={`ug[${index}].isEnglishUg`}
                            component="div"
                            className="text-error"
                          />
                        </Form.Group>
                      </Col>



                    </Row>
                  </div>
                  <Row>
                    <Col xxl={12} xl={12} lg={12} md={12} sm={12} xs={12} className='mb-3'>
                      <div className='float-end'><button type="button" className="button-titile btn btn-sm btn-success mb-2 btn-end"
                        onClick={() => {
                          // setPqLen(Formik.values?.pq?.length)
                          formikFieldArray.push({
                            univCode: "",
                            mediumId: "",
                            yearOfPass: "",
                            hallTicket: "",
                            totalMarks: "",
                            marksSecured: "",
                            percentage: "",
                            subject1: "",
                            subject2: "",
                            subject3: "",
                            subject4: "",
                            secondLanguage: "",
                            courseCode: "",
                            isEnglishUg:""
                          })
                        }}
                      >
                        <VscDiffAdded style={{ fontSize: "20px" }}></VscDiffAdded> UG
                      </button>
                        {(Formik.values.ug.length >= 2) ? (<>
                          &emsp;<button type="button"
                            className="button-titile btn btn-sm btn-danger mb-2"
                            onClick={() => {
                              pqDeleteRow(experienceDetails?.courseCode, Formik);
                              formikFieldArray.remove(index);

                            }}>
                            <BiTrash style={{ fontSize: "20px" }}></BiTrash></button>
                        </>) : ("")}</div>
                    </Col>
                  </Row>
                </div>
              );
            });
          }}
        </FieldArray>
      </div></div>
    </React.Fragment>
  )
}